import CouponNavigationBannerContainer from './CouponNavigationBannerContainer';

export default CouponNavigationBannerContainer;
